
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M18.5 6C18.5 7.933 15.366 9.5 11.5 9.5C7.63401 9.5 4.5 7.933 4.5 6M18.5 6C18.5 4.067 15.366 2.5 11.5 2.5C7.63401 2.5 4.5 4.067 4.5 6M18.5 6V10M4.5 6V12.5M11 21.5C7.61671 21.5 5.66426 20.3076 4.84007 19.4357C4.59107 19.1723 4.5 18.8085 4.5 18.446V12.5M4.5 12.5C4.83333 13.5 6.6 15.5 11 15.5"></path><path d="M13 18.5H20M16.5 15V22"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiAdddata",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
